import { getIsMuted, getVolumeControl } from "./settings"

const clockSecondHand = document.querySelector(".clock-hand.second") as HTMLDivElement | null
const clockMinuteHand = document.querySelector(".clock-hand.minute") as HTMLDivElement | null
const clockHourHand = document.querySelector(".clock-hand.hour") as HTMLDivElement | null

export const updateClock = (currentTime: Date) => {
  if (!clockSecondHand || !clockMinuteHand || !clockHourHand) {
    throw new Error("Could not find one or more of the hands!")
  }

  const currentSecond = currentTime.getSeconds()
  const secondPercentage = currentSecond / 60
  const secondDegrees = secondPercentage * 360 - 180
  clockSecondHand.style.setProperty("transform", "rotate(" + secondDegrees + "deg)")

  const currentMinute = currentTime.getMinutes()
  const minutePercentage = currentMinute / 60
  const minuteDegrees = minutePercentage * 360 - 180 + 6 * secondPercentage
  clockMinuteHand.style.setProperty("transform", "rotate(" + minuteDegrees + "deg)")

  const currentHour = currentTime.getHours()
  const hourDegrees =
    (currentHour / 12) * 360 - 180 + 30 * minutePercentage + 0.1 * secondPercentage
  clockHourHand.style.setProperty("transform", "rotate(" + hourDegrees + "deg)")
}

export const playChime = () => {
  if (getIsMuted()) {
    return
  }

  try {
    const chimeSound = document.getElementById("chime-sound") as HTMLAudioElement | null
    if (chimeSound === null) {
      return
    }

    const volumeControl = getVolumeControl()
    chimeSound.volume = Number(volumeControl ? volumeControl.value : 0) * 0.01
    chimeSound.play()
  } catch (exception) {
    console.error("I tried to chime but your browser wouldn't let me 😢", exception)
  }
}
